document.addEventListener("DOMContentLoaded", function () {
  const sentinel = document.querySelector(".sticky-cart-sentinel");
  const cart = document.querySelector(".sticky-cart");
  const productTitle = document.querySelector("h1.product__title, .product__title, .product-title");
  const header = document.querySelector("header, .site-header, .shopify-section-header");

  if (!sentinel || !cart || !header) return;

  const headerHeight = header.offsetHeight;
  const originalParent = cart.parentElement;
  const originalNextSibling = cart.nextElementSibling;

  // Add product title in .add-wrapper if not already present
  if (productTitle) {
    const targetContainer = cart.querySelector(".add-wrapper");
    if (targetContainer && !targetContainer.querySelector(".sticky-title")) {
      const stickyTitle = document.createElement("div");
      stickyTitle.classList.add("sticky-title");
      stickyTitle.textContent = productTitle.textContent.trim();
      targetContainer.insertAdjacentElement("afterbegin", stickyTitle);
    }
  }

  // Placeholder to prevent layout jump
  const placeholder = document.createElement("div");
  placeholder.style.height = cart.offsetHeight + "px";
  placeholder.style.display = "none";
  cart.insertAdjacentElement("afterend", placeholder);

  const moveToHeader = () => {
    if (cart.dataset.sticky !== "true") {
      header.insertAdjacentElement("afterend", cart);
      cart.dataset.sticky = "true";
      cart.classList.add("is-sticky");
      cart.style.position = "fixed";
      cart.style.top = "0px";
      cart.style.left = "0";
      cart.style.width = "100%";
      cart.style.zIndex = "999";
      placeholder.style.display = "block";
    }
  };

  const moveToOriginal = () => {
    if (cart.dataset.sticky === "true") {
      cart.classList.remove("is-sticky");
      cart.style.position = "";
      cart.style.top = "";
      cart.style.left = "";
      cart.style.width = "";
      cart.style.zIndex = "";
      placeholder.style.display = "none";

      // ✅ Insert back to exact original position
      if (originalNextSibling && originalNextSibling.parentElement === originalParent) {
        originalParent.insertBefore(cart, originalNextSibling);
      } else {
        originalParent.appendChild(cart);
      }

      cart.dataset.sticky = "false";
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      const rect = sentinel.getBoundingClientRect();

      if (entry.isIntersecting || rect.top > headerHeight) {
        moveToOriginal();
      } else {
        moveToHeader();
      }
    },
    {
      rootMargin: `-${headerHeight}px 0px 0px 0px`,
      threshold: 0,
    }
  );

  observer.observe(sentinel);
});
